import styled from 'styled-components'

export const Container = styled.div`
  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
  padding-inline: 24px;
  padding-block: 17px;
  display: flex;
  flex: 1;
  border-radius: ${({ theme }) => theme.zds.border.radius100};
  flex-direction: column;
`
export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
`

export const HeaderDetails = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
`

export const HistoryButton = styled.a`
  font-family: Inter;
  font-style: normal;
  font-size: 10px;
  font-weight: 300;
  color: ${props => props.theme.colors.color122d52};
  text-decoration-line: underline;
  cursor: pointer;
`

export const IconContainer = styled.div`
  margin-right: 8px;
`

export const BehaviorTitle = styled.span`
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  color: ${props => props.theme.colors.color2d3139};
`

export const BehaviorTime = styled.span`
  font-family: Inter;
  font-weight: 300;
  font-size: 10px;
  color: ${props => props.theme.colors.color545e6c};
  margin-inline: 5px;
`
